module.exports = __webpack_public_path__ + "img/共面波导-尺寸.6844b686.svg";